import React, { useEffect, useMemo, useState } from 'react';
import { Sparkles, Image as ImageIcon, KeyRound } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import ImageUpscale from './ImageUpscale';
import TopazService from '../services/topazService';

const STORAGE_KEY = 'prezlab-topaz-key';

export function EnhancePage() {
  const [topazApiKey, setTopazApiKey] = useState(() => localStorage.getItem(STORAGE_KEY) || (process.env.REACT_APP_TOPAZ_API_KEY || ''));
  const [showKey, setShowKey] = useState(false);

  useEffect(() => {
    if (topazApiKey) {
      localStorage.setItem(STORAGE_KEY, topazApiKey);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [topazApiKey]);

  const topazService = useMemo(() => {
    if (!topazApiKey) {
      return null;
    }
    try {
      return new TopazService(topazApiKey);
    } catch (err) {
      console.error('Failed to initialise Topaz service', err);
      return null;
    }
  }, [topazApiKey]);

  return (
    <div className="p-8 space-y-8 min-h-screen max-w-7xl mx-auto">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-foreground flex items-center gap-2">
          <Sparkles className="h-7 w-7 text-accent" />
          Enhance
        </h1>
        <p className="text-lg text-muted-foreground">
          Upscale presentation imagery with Topaz Labs AI � perfect for crisp slides and export-ready assets.
        </p>
      </div>

      <div className="space-y-6">
          <Card className="bg-card/60 border-border/50">
            <CardContent className="flex items-start gap-4 p-6">
              <div className="rounded-xl bg-accent/10 p-3">
                <ImageIcon className="h-6 w-6 text-accent" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-foreground">Bulk image enhancement</h2>
                <p className="text-sm text-foreground/70 mt-1">
                  Drop hero images, photography, or screenshots and upscale them 2× with Topaz Labs. Perfect for high-resolution exports and brand-critical presentations.
                </p>
              </div>
            </CardContent>
          </Card>

        <ImageUpscale topazService={topazService} />
      </div>
    </div>
  );
}
